import React from 'react';

interface WeekNavigationProps {
    currentWeekStart: Date;
    onPreviousWeek: () => void;
    onNextWeek: () => void;
    onCurrentWeek: () => void;
}

export const WeekNavigation: React.FC<WeekNavigationProps> = ({
    currentWeekStart,
    onPreviousWeek,
    onNextWeek,
    onCurrentWeek
}) => {
    const formatWeekRange = (startDate: Date) => {
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        
        const options: Intl.DateTimeFormatOptions = { 
            day: '2-digit', 
            month: 'long', 
            year: 'numeric' 
        };
        
        const start = startDate.toLocaleDateString('fr-FR', options);
        const end = endDate.toLocaleDateString('fr-FR', options);
        
        return `${start} - ${end}`;
    };

    const getMonthYear = (date: Date) => {
        return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });
    };

    const isCurrentWeek = () => {
        const now = new Date();
        const currentMonday = new Date(now);
        const dayOfWeek = now.getDay();
        const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
        currentMonday.setDate(now.getDate() + daysToMonday);
        currentMonday.setHours(0, 0, 0, 0);
        
        const weekStartCopy = new Date(currentWeekStart);
        weekStartCopy.setHours(0, 0, 0, 0);
        
        return currentMonday.getTime() === weekStartCopy.getTime();
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-xl font-semibold text-gray-900">
                        Planning - {getMonthYear(currentWeekStart)}
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                        Semaine du {formatWeekRange(currentWeekStart)}
                    </p>
                </div>
                
                <div className="flex items-center space-x-2">
                    <button
                        onClick={onPreviousWeek}
                        className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                        title="Semaine précédente"
                    >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    
                    {!isCurrentWeek() && (
                        <button
                            onClick={onCurrentWeek}
                            className="px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
                        >
                            Aujourd'hui
                        </button>
                    )}
                    
                    <button
                        onClick={onNextWeek}
                        className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                        title="Semaine suivante"
                    >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};